import { useSelector } from 'react-redux'
import { useState } from 'react'
import SearchLabel from './SearchLabel'
import ClearAll from './ClearAll'
import useWindowDimensions from '../../../hooks/useWindowDimensions'

const SearchLabels = () => {
  const searchLabels = useSelector((state) => state.items.searchLabels || [])
  const [showAll, setShowAll] = useState(false)
  const dimensions = useWindowDimensions()

  const maxLabels = () => {
    if (showAll) return
    if (dimensions.width <= 992) return 4
    if (dimensions.width <= 1200) return 6
    if (dimensions.width <= 1400) return 8

    return 10
  }

  return (
    <div id="label-resize-container">
      {searchLabels.slice(0, maxLabels()).map((searchLabel) => (
        <SearchLabel searchLabel={searchLabel} key={searchLabel.key} />
      ))}
      {searchLabels.length > maxLabels() && !showAll && (
        <button
          type="button"
          className="btn btn-sm py-1 my-1 me-1 rounded-8"
          style={{ backgroundColor: '#EDE9E5' }}
          onClick={() => setShowAll(true)}
        >
          <b>+ {searchLabels.length - maxLabels()} filters</b>
        </button>
      )}
      {searchLabels.length > 0 && (
        <div
          className="vr ms-2 me-2"
          style={{
            color: '#343434',
            height: '20px',
            transform: 'translateY(30%)',
          }}
        />
      )}
      <ClearAll onClick={() => setShowAll(false)} />
      {showAll && (
        <div>
          <button className="btn btn-sm" onClick={() => setShowAll(false)}>
            {I18n.t('show_less')}
          </button>
        </div>
      )}
    </div>
  )
}

export default SearchLabels
